// src/App.tsx??
import AppLayout from './AppLayout';

export default function App() {
  return <AppLayout />;
}
